export function readJsonStorage(key, defaultValue) {
  try {
    const text = localStorage.getItem(key)
    return text ? JSON.parse(text) : defaultValue
  } catch (error) {
    return defaultValue
  }
}

export function normalizeSchoolInfo(school = {}) {
  const schoolId = school.schoolId || school.id || ''
  const schoolName = school.schoolName || school.name || school.school || ''
  return Object.assign({}, school, {
    schoolId,
    schoolName
  })
}

let schoolStore = null

export function bindSchoolStore(store) {
  schoolStore = store
}

function getStoreSchoolInfo() {
  const schoolInfo = schoolStore && schoolStore.getters && schoolStore.getters.currentSchoolInfo
  return schoolInfo ? normalizeSchoolInfo(schoolInfo) : normalizeSchoolInfo({})
}

export function getCurrentSchoolInfo() {
  const storeSchoolInfo = getStoreSchoolInfo()
  if (storeSchoolInfo.schoolId || storeSchoolInfo.schoolName) {
    return storeSchoolInfo
  }
  const schoolInfo = normalizeSchoolInfo(readJsonStorage('schoolInfo', {}))
  if (schoolInfo.schoolId || schoolInfo.schoolName) {
    return schoolInfo
  }
  const userInfo = readJsonStorage('userInfo', {})
  return normalizeSchoolInfo({
    schoolId: localStorage.getItem('schoolId') || userInfo.schoolId || '',
    schoolName: userInfo.schoolName || userInfo.school || ''
  })
}

export function setCurrentSchoolInfo(school) {
  const next = normalizeSchoolInfo(school)
  if (schoolStore) {
    schoolStore.commit('setCurrentSchoolInfo', next)
  }
  if (next.schoolId) {
    localStorage.setItem('schoolId', next.schoolId)
  } else {
    localStorage.removeItem('schoolId')
  }
  localStorage.setItem('schoolInfo', JSON.stringify(next))

  const userInfo = readJsonStorage('userInfo', {})
  const nextUserInfo = Object.assign({}, userInfo, {
    schoolId: next.schoolId,
    schoolName: next.schoolName,
    school: next.schoolName
  })
  localStorage.setItem('userInfo', JSON.stringify(nextUserInfo))
  window.dispatchEvent(new CustomEvent('app-user-info-updated', { detail: nextUserInfo }))
  window.dispatchEvent(new CustomEvent('app-school-changed', { detail: next }))
  return next
}

export function clearCurrentSchoolInfo() {
  if (schoolStore) {
    schoolStore.commit('clearCurrentSchoolInfo')
  }
  localStorage.removeItem('schoolId')
  localStorage.removeItem('schoolInfo')
  const userInfo = readJsonStorage('userInfo', null)
  if (userInfo) {
    delete userInfo.schoolId
    delete userInfo.schoolName
    delete userInfo.school
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  }
}



// WEBPACK FOOTER //
// ./src/utils/schoolContext.js